import React, { useState, useEffect } from 'react';
import { Table, Container, Input, Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import CreateTableComponent from "../../share/CreateTableComponent";
import { NumberWithCommas } from '../../share/NumberWithCommas';

export function Report57Component() {
    const [budgetYear, setBudgetYear] = useState(new Date().getFullYear() + 543);
    const [reportData, setReportData] = useState([]);
    console.log("reportData", reportData);
    const [supportTypeId, setSupportTypeId] = useState(0);
    const [openModalForm, setOpenModalForm] = React.useState(false);
    const [R57detailfilter, setR57detailfilter] = React.useState([]);
    const [Re57yeardata, setRe57yeardata] = React.useState([]);

    async function getR57() {
        const formData = new FormData();
        formData.append("thYear", budgetYear);
        const res57 = await fetch("/api/Support/getR57", {
            method: 'POST',
            body: formData
        });
        const Re57data = await res57.json();
        setReportData(Re57data.dataenum || []);
    }

    async function getR57year() {
        const res = await fetch("/api/Support/getyear56");
        const Re57yeardata = await res.json();
        setRe57yeardata(Re57yeardata.dataenum || []);
    }

    useEffect(() => {
        getR57();
        getR57year();
    }, [budgetYear]);

    async function GetReportDetail(supportTypeId) {
        const formData = new FormData();
        formData.append("budgetYear", budgetYear);
        formData.append("supportTypeId", supportTypeId);
        try {
            const res = await fetch("/api/Support/getR57detail", {
                method: 'POST',
                body: formData
            });
            const resJson = await res.json();
            setR57detailfilter(resJson.dataenum || []);
        } catch (e) {
            console.error(e);
        }
        modalToggleExtendCourse();
    }

    const modalToggleExtendCourse = () => setOpenModalForm(!openModalForm);

    const columns = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "ชื่อผู้ได้รับเงินช่วยเหลือหรืออุดหนุน",
            accessor: "supportName",
        },
        {
            Header: "เลขที่คำขอ",
            accessor: "supportNo",
        },
        {
            Header: "จำนวนเงิน",
            accessor: "amount",
            Cell: ({ value }) => (<>{NumberWithCommas(value)}</>)
        },
    ];

    const columnsForAnnounce12and13 = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "สาขาอาชีพ",
            accessor: "lawOccupationName",
        },
        {
            Header: "สาขา",
            accessor: "testOccupationName",
        },
        {
            Header: "ระดับ",
            accessor: "stdLevelTname",
        },
        {
            Header: "จำนวนเงิน",
            accessor: "amount",
            Cell: ({ value }) => (<>{NumberWithCommas(value)}</>)
        }
    ];

    // ====== คำนวณผลรวมไว้ใช้ใน tfoot ======
    const totalBudget = reportData.reduce((sum, item, i) => {
        if (i === 7) return sum;
        return sum + (Number(item.budget) || 0);
    }, 0);
    const totalCompanyTotal = reportData.reduce(
        (sum, item) => sum + (Number(item.companyTotal) || 0),
        0
    );
    const totalPersonTotal = reportData.reduce(
        (sum, item) => sum + (Number(item.personTotal) || 0),
        0
    );
    const totalAmount = reportData.reduce(
        (sum, item) => sum + (Number(item.amount) || 0),
        0
    );
    const totalPerc = reportData.reduce(
        (sum, item) => sum + (Number(item.perc) || 0),
        0
    );
    const totalPerP = reportData.reduce(
        (sum, item) => sum + (Number(item.perP) || 0),
        0
    );
    const totalBalance = reportData.reduce(
        (sum, item) => sum + (Number(item.balance) || 0),
        0
    );
    const totalPercBal = reportData.reduce(
        (sum, item) => sum + (Number(item.percBal) || 0),
        0
    );

    return (
        <Container>
            <div>
                <div className="d-flex justify-content-center align-items-center flex-wrap">
                    <span className='text-center me-2 fs-5'>
                        ปีงบประมาณ พ.ศ.
                    </span>
                    <Input
                        className='w-25 fs-5'
                        type="select"
                        value={budgetYear}
                        onChange={(e) => {
                            setBudgetYear(e.target.value);
                        }}
                    >
                        {Re57yeardata?.map((item, i) => (
                            <option key={i} value={item.yearTh}>
                                {item.yearTh}
                            </option>
                        ))}
                    </Input>
                </div>
                <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/Support/xlsxR57?thYear=${budgetYear}`} download>
                            Export EXCEL
                        </Button>
                        <Button className="btn2" href={`api/Support/pdfR57?thYear=${budgetYear}`} download>
                            Export PDF
                        </Button>
                    </Col>
                </Row>
                <div className="outer-wrapper">
                    <div className="table-wrapper">
                        <Table className="styled-table" bordered striped hover>
                            <thead>
                                <tr>
                                    <td rowSpan="3">
                                        ลำดับ
                                    </td>
                                    <th rowSpan="3" className='text-center'>
                                        รายการ
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        งบประมาณปี {budgetYear}
                                    </th>
                                    <th colSpan="4" className=' text-center'>
                                        อนุมัติเงินอุดหนุน
                                    </th>
                                    <th rowSpan="3" className=' text-center'>
                                        สัดส่วนอนุมัติ ร้อยละ
                                    </th>
                                    <th colSpan="2" className=' text-center'>
                                        งบประมาณคงเหลือ
                                    </th>
                                </tr>
                                <tr>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        ร้อยละ
                                    </th>

                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        ร้อยละ
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {!reportData?.length ? (
                                    <tr>
                                        <td colSpan="10" className='text-center'>ไม่มีข้อมูล</td>
                                    </tr>
                                ) : (
                                    reportData?.map((item, i) => (
                                        <tr key={i} hidden={i == 5 ? true : false}>
                                            <td className='text-center'>
                                                {i + 1}
                                            </td>
                                            <td className='text-start'>
                                                {item.supportDetail}
                                            </td>
                                            <td
                                                className='text-end'
                                                rowSpan={i === 7 ? 2 : null}
                                                hidden={i === 8 ? true : false}
                                            >
                                                {NumberWithCommas(item.budget)}
                                            </td>
                                            <td className='text-end'>
                                                <span
                                                    style={{ cursor: 'pointer' }}
                                                    id={item.supportDetail}
                                                    onClick={() => {
                                                        setSupportTypeId(item.supportTypeId);
                                                        GetReportDetail(item.supportTypeId);
                                                    }}
                                                >
                                                    {NumberWithCommas(Number(item.companyTotal))}
                                                </span>
                                            </td>
                                            <td className='text-end'>
                                                {NumberWithCommas(item.personTotal)}
                                            </td>
                                            <td className='text-end'>
                                                {NumberWithCommas(item.amount)}
                                            </td>
                                            <td className='text-end'>
                                                {NumberWithCommas(item.perc)}
                                            </td>
                                            <td className='text-end'>
                                                {NumberWithCommas(item.perP)}
                                            </td>
                                            <td
                                                className='text-end'
                                                rowSpan={i === 7 ? 2 : null}
                                                hidden={i === 8 ? true : false}
                                            >
                                                {NumberWithCommas(item.balance)}
                                            </td>
                                            <td
                                                className='text-end'
                                                rowSpan={i === 7 ? 2 : null}
                                                hidden={i === 8 ? true : false}
                                            >
                                                {NumberWithCommas(item.percBal)}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>

                            {/* ====== สรุปรวมใน tfoot ====== */}
                            {reportData?.length > 0 && (
                                <tfoot>
                                    <tr>
                                        <td colSpan="2" className="text-center fw-bold">
                                            รวม
                                        </td>
                                        <td className="text-end fw-bold">
                                            {NumberWithCommas(totalBudget)}
                                        </td>
                                        <td className="text-end fw-bold">
                                            {NumberWithCommas(totalCompanyTotal)}
                                        </td>
                                        <td className="text-end fw-bold">
                                            {NumberWithCommas(totalPersonTotal)}
                                        </td>
                                        <td className="text-end fw-bold">
                                            {NumberWithCommas(totalAmount)}
                                        </td>
                                        <td className="text-end fw-bold">
                                            {NumberWithCommas(totalPerc)}
                                        </td>
                                        <td className="text-end fw-bold">
                                            {NumberWithCommas(totalPerP)}
                                        </td>
                                        <td className="text-end fw-bold">
                                            {NumberWithCommas(totalBalance)}
                                        </td>
                                        <td className="text-end fw-bold">
                                            {NumberWithCommas(totalPercBal)}
                                        </td>
                                    </tr>
                                </tfoot>
                            )}
                        </Table>
                    </div>
                </div>
            </div>

            <Modal
                isOpen={openModalForm}
                toggle={modalToggleExtendCourse}
                centered
                scrollable
                backdrop={'static'}
                keyboard={false}
                size="xl"
                className="modal-bordered"
            >
                <ModalHeader toggle={modalToggleExtendCourse} className="styled-modal text-center">
                    รายละเอียดข้อมูล
                </ModalHeader>
                <ModalBody>
                    <CreateTableComponent
                        column={supportTypeId === 10 || supportTypeId === 11 ? columnsForAnnounce12and13 : columns}
                        dataInput={R57detailfilter}
                        showEntrie={true}
                        showPage={true}
                    />
                </ModalBody>
            </Modal>
        </Container>
    );
}
